import React, { useState } from 'react';
import { IoChevronDown } from 'react-icons/io5';

interface AccordionFilterProps {
  title: string;
  content: React.ReactNode;
}

const AccordionFilter: React.FC<AccordionFilterProps> = ({
  title,
  content,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="overflow-hidden rounded-md bg-gray-50/50 hover:bg-gray-50 dark:bg-gray-800/50 dark:hover:bg-gray-800/80">
      <button
        className="flex w-full items-center justify-between px-3 py-2 text-left text-gray-700 transition-colors duration-200 dark:text-gray-200"
        onClick={toggleAccordion}
      >
        <span className="font-medium">{title}</span>
        <div
          className={`transform text-gray-400 transition-transform duration-300 dark:text-gray-500 ${
            isOpen ? 'rotate-180' : 'rotate-0'
          }`}
        >
          <IoChevronDown className="text-lg" />
        </div>
      </button>
      <div
        className={`grid overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
        }`}
      >
        <div className="overflow-hidden">
          <div className="px-3 pb-2">{content}</div>
        </div>
      </div>
    </div>
  );
};

export default AccordionFilter;
